import { configureStore } from '@reduxjs/toolkit';
import { createPromise } from 'redux-promise-middleware';
import rootReducer from '../slices';

const PROMISE_TYPE_SUFFIXES = ['PENDING', 'FULLFILLED', 'REJECTED'];

const devMode = process.env.NODE_ENV === 'development';

const promiseMiddleWare = createPromise({
  promiseTypeSuffixes: PROMISE_TYPE_SUFFIXES
});

const store = configureStore({
  reducer: rootReducer,
  devTools: devMode,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }).concat(promiseMiddleWare)
});

export default store;
